let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2ttaJ")).then(() => parcelRequire('7tXIZ'));